import React from "react";
import icon1 from "../img/Mask Group 21.png";

const NewsCard = ({ newsData }) => {
  return (
    <>
      <section className="news">
        <p className="news-p1">Latest News</p>
        <h1 className="news-h1">Our Insight & Article</h1>
        <div className="news-cards">
          {newsData.map((curEle) => {
            return (
              <>
                <div className="card-1">
                  <img src={icon1} alt="" className="news-img" />
                  <div className="date">{curEle.date}</div>
                  <span className="content">
                    <p className="admin">{curEle.admin}</p>
                    <p className="air">{curEle.air}</p>
                  </span>
                  <h4 className="description">{curEle.heading}</h4>
                  <div className="read">{curEle.read}</div>
                </div>
              </>
            );
          })}
        </div>
      </section>
    </>
  );
};

export default NewsCard;
